import { Skeleton } from '@/components/ui/skeleton';

export function LoadingCards({ count = 4 }) {
  return (
    <div className="space-y-3" data-testid="loading-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="border border-slate-800 rounded-xl p-4 bg-slate-900/50">
          <div className="flex justify-between mb-3">
            <Skeleton className="h-5 w-24 bg-slate-800" />
            <Skeleton className="h-4 w-20 bg-slate-800" />
          </div>
          <Skeleton className="h-4 w-48 bg-slate-800 mb-2" />
          <Skeleton className="h-4 w-40 bg-slate-800" />
        </div>
      ))}
    </div>
  );
}

export function LoadingTable() {
  return (
    <div className="border border-slate-800 rounded-lg p-4 bg-slate-900/50 space-y-2" data-testid="loading-table">
      <Skeleton className="h-8 w-full bg-slate-800" />
      {Array.from({ length: 6 }).map((_, i) => (
        <Skeleton key={i} className="h-10 w-full bg-slate-800" />
      ))}
    </div>
  );
}

export function LoadingPage() {
  return (
    <div className="container mx-auto px-4 max-w-7xl py-8 space-y-6" data-testid="loading-page">
      <Skeleton className="h-10 w-64 bg-slate-800" />
      <Skeleton className="h-6 w-96 bg-slate-800" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-24 bg-slate-800 rounded-xl" />
        ))}
      </div>
      <LoadingCards count={3} />
    </div>
  );
}
